module.exports = "/_next/static/chromiums/twitter-512x512-people-24dd4117c96802af805464083ade168b.jpg";